export const theme = {
  colors: {
    primary: '#22d3ee',
    primaryDark: '#0ea5e9',
    primaryLight: '#67e8f9',
    secondary: '#a78bfa',
    success: '#34d399',
    error: '#f87171',
    warning: '#f59e0b',
    info: '#38bdf8',
    
    // Neutral colors
    white: '#ffffff',
    gray50: '#0b1224',
    gray100: '#0f172a',
    gray200: '#1e293b',
    gray300: '#273449',
    gray400: '#334155',
    gray500: '#475569',
    gray600: '#64748b',
    gray700: '#94a3b8',
    gray800: '#cbd5e1',
    gray900: '#e2e8f0',
    
    // Background colors
    background: '#050816',
    backgroundSecondary: '#0b1021',
    surface: '#0f172a',
    
    // Text colors
    textPrimary: '#e5e7eb',
    textSecondary: '#9ca3af',
    textTertiary: '#94a3b8',
  },
  
  spacing: {
    xs: '0.25rem',
    sm: '0.5rem',
    md: '1rem',
    lg: '1.5rem',
    xl: '2rem',
    '2xl': '3rem',
    '3xl': '4rem',
    '4xl': '6rem',
  },
  
  borderRadius: {
    none: '0',
    sm: '0.125rem',
    md: '0.375rem',
    lg: '0.5rem',
    xl: '0.75rem',
    '2xl': '1rem',
    '3xl': '1.5rem',
    full: '9999px',
  },
  
  shadows: {
    sm: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
    md: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
    lg: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
    xl: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
    '2xl': '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
  },
  
  fonts: {
    body: "'Space Grotesk', 'Inter', 'IBM Plex Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
    heading: "'Space Grotesk', 'Inter', 'IBM Plex Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
  },
  
  fontSizes: {
    xs: '0.75rem',
    sm: '0.875rem',
    md: '1rem',
    lg: '1.125rem',
    xl: '1.25rem',
    '2xl': '1.5rem',
    '3xl': '1.875rem',
    '4xl': '2.25rem',
    '5xl': '3rem',
  },
  
  fontWeights: {
    light: 300,
    normal: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
  },
  
  breakpoints: {
    sm: '640px',
    md: '768px',
    lg: '1024px',
    xl: '1280px',
    '2xl': '1536px',
  },
  
  transitions: {
    fast: '150ms ease-in-out',
    normal: '300ms ease-in-out',
    slow: '500ms ease-in-out',
  },
};
